export default __webpack_public_path__ + "static/MultimunicipalComprehensivePlans-26aa66d3c18d16a75531a41d972ebae8.jpg";